import React, { useState, useRef, useCallback } from "react";
import { Offer } from "../config/siteConfig";
// import image1 from "../assets/2_brothas_photobooth.png";
// import image2 from "../assets/premium_card.jpg";
// import image3 from "../assets/prestige_card.jpg";

import image1 from "../assets/2guys.jpeg"
import image2 from "../assets/2_whites_dancing.jpeg"
import image3 from "../assets/3_queens_dancing.webp"



const CARD_IMAGES: Record<number, string> = { 1: image1, 2: image2, 3: image3 };

interface ParallaxCardProps {
  offer: Offer;
}

const ParallaxCard: React.FC<ParallaxCardProps> = ({ offer }) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [transform, setTransform] = useState({
    rotateX: 0,
    rotateY: 0,
    bgX: 0,
    bgY: 0,
  });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = useCallback(
    (e: React.MouseEvent) => {
      if (!cardRef.current) return;
      const rect = cardRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      setTransform({
        rotateY: (x / rect.width) * 25,
        rotateX: (y / rect.height) * -25,
        bgX: (x / rect.width) * -30,
        bgY: (y / rect.height) * -30,
      });
    },
    []
  );

  const handleMouseLeave = () => {
    setTransform({ rotateX: 0, rotateY: 0, bgX: 0, bgY: 0 });
    setIsHovering(false);
  };

  const cardImage = CARD_IMAGES[offer.id];

  return (
    <div
      ref={cardRef}
      onMouseMove={(e) => {
        handleMouseMove(e);
        setIsHovering(true);
      }}
      onMouseLeave={handleMouseLeave}
      className="w-full cursor-pointer"
      style={{ perspective: "800px" }}
    >
      <div
        className="relative rounded-lg overflow-hidden transition-transform duration-300 ease-out"
        style={{
          transform: `rotateY(${transform.rotateY}deg) rotateX(${transform.rotateX}deg)`,
          height: "420px",
          boxShadow: isHovering
            ? `0 0 15px ${offer.accent}40, 0 0 30px ${offer.accent}20, 0 0 45px ${offer.accent}10`
            : "0 4px 30px rgba(0,0,0,0.5)",
          border: isHovering
            ? `2px solid ${offer.accent}`
            : "2px solid transparent",
        }}
      >
        {/* Background image avec parallax */}
        <div
          className="absolute transition-transform duration-300 ease-out"
          style={{
            top: "-5%",
            left: "-5%",
            width: "110%",
            height: "110%",
            transform: `translateX(${transform.bgX}px) translateY(${transform.bgY}px)`,
            opacity: isHovering ? 0.7 : 0.5,
            ...(cardImage
              ? {
                  backgroundImage: `url(${cardImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center top",
                }
              : {
                  background: `radial-gradient(ellipse at 50% 30%, ${offer.accent}30, #111 70%)`,
                }),
          }}
        />

        {/* Infos en bas */}
        <div
          className="absolute bottom-0 left-0 right-0 p-6 z-10"
          style={{
            background:
              "linear-gradient(to top, rgba(0,0,0,0.9) 0%, transparent 100%)",
          }}
        >
          {offer.popular && (
            <span
              className="inline-block px-2.5 py-0.5 text-[10px] tracking-[0.15em] uppercase rounded-sm mb-3"
              style={{
                background: offer.accent + "20",
                color: offer.accent,
                border: `1px solid ${offer.accent}40`,
              }}
            >
              Populaire
            </span>
          )}
          <h3 className="text-2xl font-bold text-white mb-1 font-display">
            {offer.persons}
          </h3>
          <p style={{ color: offer.accent }}>
            {offer.price}{" "}
            <span className="text-sm text-zinc-400 font-normal">
              / {offer.duration}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ParallaxCard;
